import { Appointment } from "@elixir/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getAllQueuesQuery } from "./get-all-queues";
import { AllQueuesData } from "./types";
import tagAppointment from "../../controllers/appointments/tag-apt";

const usePostTagAnAppointment = ({
  date,
  clinicId,
  queueType,
}: {
  date: string;
  clinicId: string;
  queueType: keyof AllQueuesData;
}) => {
  const queryClient = useQueryClient();
  return useMutation(tagAppointment, {
    onMutate: ({ appointment: { aid }, tagId }) => {
      queryClient.setQueryData<AllQueuesData>(
        getAllQueuesQuery({ startDate: date, clinicId }),
        (old) => {
          const aptsToChange = old?.[queueType];
          const aptToChangeIndex = aptsToChange?.findIndex(
            (apt) => apt.aid === aid
          );

          if (
            !aptsToChange ||
            typeof aptToChangeIndex === "undefined" ||
            aptToChangeIndex < 0
          ) {
            return old as AllQueuesData;
          }

          const aptToChange = aptsToChange[aptToChangeIndex];
          const existingTags = new Set(aptToChange.tags);

          if (existingTags.has(tagId)) {
            existingTags.delete(tagId);
          } else {
            existingTags.add(tagId);
          }

          const updatedApt: Appointment = {
            ...aptToChange,
            tags: Array.from(existingTags),
          };

          const updatedApts = {
            ...old,
            [queueType]: [
              ...aptsToChange.slice(0, aptToChangeIndex),
              updatedApt,
              ...aptsToChange.slice(aptToChangeIndex + 1),
            ],
          };

          return updatedApts;
        }
      );
    },
  });
};

export default usePostTagAnAppointment;
